// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal[data-v-556621d3]{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;display:block;overflow:hidden;outline:0;background-color:rgba(0,0,0,.6)}.modal-dialog[data-v-556621d3]{position:relative;top:35%;transform:translateY(-50%)}.modal-body[data-v-556621d3]{text-align:center}", ""]);
// Exports
module.exports = exports;
